import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "exception", {
        description: String(error?.message || error),
        fatal: true,
      });
    }
  }

  handleReload = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          className="min-h-screen bg-[#1A1A1A] flex flex-col items-center justify-center px-6 text-center"
        >
          <img
            src="/images/justfit-logo.webp"
            alt="Justfit"
            width="140"
            height="46"
            className="mb-8"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
          <h1 className="text-white text-2xl sm:text-3xl font-bold mb-3">
            Ocorreu um erro inesperado
          </h1>
          <p className="text-gray-400 text-base mb-8 max-w-md">
            Pedimos desculpa pelo incómodo. Por favor, recarrega a página ou volta à página inicial.
          </p>
          <button
            data-testid="error-boundary-home-btn"
            onClick={this.handleReload}
            className="bg-[#E8FE54] text-[#1A1A1A] font-bold px-8 py-3 rounded-full hover:brightness-95 transition-[filter]"
          >
            Voltar ao início
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
